import {
  Box,
  Button,
  Container,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import ContentPage from "../Components/ContentPage";
import HomeIcon from "@mui/icons-material/Home";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteSweepTwoToneIcon from "@mui/icons-material/DeleteSweepTwoTone";
import DataTable from "../Components/Table/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { departmentDetailList } from "../store/Slice/departmentDetailSlice";
import Swal from "sweetalert2";
import {
  labFormCreate,
  labFormDelete,
  labFormList,
  labFormUpdate,
} from "../store/Slice/labFormSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import SaveAltIcon from "@mui/icons-material/SaveAlt";

export default function LabFormList() {
  const dispatch = useDispatch();
  const labForm = useSelector(({ labForm }) => labForm);

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    dispatch(labFormList());
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      flag: "create",
      lab_form_id: "",
      lab_form_name: "",
    },
    validationSchema: Yup.object().shape({
      lab_form_id: Yup.string().required("ระบุ ID"),
      lab_form_name: Yup.string().required("ระบุ Lab Form"),
    }),
    onSubmit: (values) => {
      console.log(values);
      if (values.flag === "create") {
        dispatch(labFormCreate(values)).then(() => {
          dispatch(labFormList());
          handleClose();
        });
      } else {
        dispatch(labFormUpdate(values)).then(() => {
          dispatch(labFormList());
          handleClose();
        });
      }
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };
  const handleClickEdit = (data) => {
    formik.setFieldValue("flag", "edit");
    formik.setFieldValue("lab_form_id", data.lab_form_id);
    formik.setFieldValue("lab_form_name", data.lab_form_name);
    setOpen(true);
  };

  const rows = labForm.result;
  const columns = [
    {
      field: "#",
      headerName: "#",
      width: 30,
    },
    {
      field: "lab_form_id",
      headerName: "ID",
    },
    {
      field: "lab_form_name",
      headerName: "Lab Form",
    },
    {
      field: "actions",
      headerName: "Actions",
      numeric: "center",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              startIcon={<EditTwoToneIcon />}
              sx={{ mr: 2 }}
              onClick={() => handleClickEdit(row)}
            >
              แก้ไข
            </Button>
            <Button
              variant="contained"
              startIcon={<DeleteSweepTwoToneIcon />}
              color="error"
              onClick={() => {
                Swal.fire({
                  title: "คุณต้องการลบข้อมูลหรือไม่",
                  text: row.lab_form_name,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#FF8C00",
                  cancelButtonColor: "#FF4500",
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก",
                  customClass: {
                    title: "sweetalert-title", // Apply Sarabun font to the title
                    content: "sweetalert-content", // Apply Sarabun font to the content
                    confirmButton: "sweetalert-confirm-button",
                    cancelButton: "sweetalert-cancel-button",
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    dispatch(
                      labFormDelete({ lab_form_id: row.lab_form_id })
                    ).then(() => {
                      dispatch(labFormList());
                    });
                    Swal.fire({
                      title: "ลบ!",
                      text: "ลบข้อมูลเรียบร้อย",
                      icon: "success",
                    });
                  }
                });
              }}
            >
              ลบ
            </Button>
          </Box>
        );
      },
    },
  ];
  return (
    <Container maxWidth={"xl"}>
      <ContentPage
        image_icon={process.env.PUBLIC_URL + "/icons/test.png"}
        title="Lab Form"
        TitlePageMenulist={[
          {
            label: "หน้าแรก",
            href: "/lab",
            icon: <HomeIcon fontSize="small" />,
          },
          {
            label: "Data Master",
            href: "#",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
          {
            label: "Lab Form",
            href: "/lab/lab-form",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
        ]}
        btnAction={
          <Button
            variant="contained"
            startIcon={<AddCircleTwoToneIcon />}
            onClick={handleClickOpen}
          >
            เพิ่ม Lab Form
          </Button>
        }
      >
        <Paper elevation={0} sx={{ p: 1 }}>
          <DataTable columns={columns} rows={rows} />
        </Paper>
      </ContentPage>
      <Dialog
        open={open}
        fullWidth
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        component={"form"}
        onSubmit={formik.handleSubmit}
      >
        <DialogTitle id="alert-dialog-title">
          {formik.values.flag === "edit" ? "แก้ไข" : "เพิ่ม"}จุดตรวจ
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            direction={"row"}
            justifyContent={"flex-start"}
            spacing={2}
            mt={1}
          >
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                id="lab_form_id"
                name="lab_form_id"
                value={formik.values.lab_form_id}
                label="ID"
                size="small"
                variant="outlined"
                onChange={formik.handleChange}
                error={Boolean(formik.errors.lab_form_id)}
                helperText={formik.errors.lab_form_id}
                disabled={formik.values.flag === "edit"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                id="lab_form_name"
                name="lab_form_name"
                value={formik.values.lab_form_name}
                label="Lab Form"
                size="small"
                variant="outlined"
                onChange={formik.handleChange}
                error={Boolean(formik.errors.lab_form_name)}
                helperText={formik.errors.lab_form_name}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleClose}
            color="error"
            startIcon={<CloseIcon />}
          >
            ปิด
          </Button>
          <Button
            variant="contained"
            type="submit"
            autoFocus
            startIcon={<SaveAltIcon />}
          >
            {formik.values.flag === "edit" ? "อัพเดท" : "บันทึก"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
